'use client'

import Image from 'next/image'
import Link from 'next/link'
import posthog from 'posthog-js'

export function Footer() {
  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-6">
        {/* Navigation Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-10 max-w-3xl mx-auto mb-16">
          <div>
            <h3 className="text-lg font-semibold mb-3">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  href="/info/about" 
                  onClick={() => {
                    posthog.capture('footer_link_clicked', {
                      section: 'company',
                      link: 'about',
                      path: '/info/about'
                    })
                  }} 
                  className="hover:text-mixus-pumpkin transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  href="/info/team" 
                  onClick={() => {
                    posthog.capture('footer_link_clicked', {
                      section: 'company',
                      link: 'team',
                      path: '/info/team'
                    })
                  }} 
                  className="hover:text-mixus-pumpkin transition-colors"
                >
                  Team
                </Link>
              </li>
            </ul>
          </div>
          {/* <div>
            <h3 className="text-lg font-semibold mb-3">Features</h3>
            <ul className="space-y-2"> */}
              {/* <li>
                <Link 
                  href="/discover" 
                  onClick={() => {
                    posthog.capture('footer_link_clicked', {
                      section: 'features',
                      link: 'discover',
                      path: '/discover'
                    })
                  }} 
                  className="hover:text-mixus-pumpkin transition-colors"
                >
                  Discover Public Chats
                </Link>
              </li> */}
              {/* <li>
                <Link 
                  href="/pricing" 
                  onClick={() => {
                    posthog.capture('footer_link_clicked', {
                      section: 'features',
                      link: 'pricing',
                      path: '/pricing'
                    })
                  }} 
                  className="hover:text-mixus-pumpkin transition-colors"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div> */}
          <div>
            <h3 className="text-lg font-semibold mb-3">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  href="/info/faq" 
                  onClick={() => {
                    posthog.capture('footer_link_clicked', {
                      section: 'support',
                      link: 'faq',
                      path: '/info/faq'
                    })
                  }} 
                  className="hover:text-mixus-pumpkin transition-colors"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link 
                  href="/info/privacy-policy" 
                  onClick={() => {
                    posthog.capture('footer_link_clicked', {
                      section: 'support',
                      link: 'privacy_policy',
                      path: '/info/privacy-policy'
                    })
                  }} 
                  className="hover:text-mixus-pumpkin transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  href="/info/terms-of-use" 
                  onClick={() => {
                    posthog.capture('footer_link_clicked', {
                      section: 'support',
                      link: 'terms_of_service',
                      path: '/info/terms-of-use'
                    })
                  }} 
                  className="hover:text-mixus-pumpkin transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-3">Account</h3>
            <ul className="space-y-2">
              {/* <li>
                <Link 
                  href="/sign-up" 
                  onClick={() => {
                    posthog.capture('footer_link_clicked', {
                      section: 'account',
                      link: 'sign_up',
                      path: '/sign-up'
                    })
                  }} 
                  className="hover:text-mixus-pumpkin transition-colors"
                >
                  Sign-Up
                </Link>
              </li> */}
              <li>
                <Link 
                  href="/sign-in" 
                  onClick={() => {
                    posthog.capture('footer_link_clicked', {
                      section: 'account',
                      link: 'sign_in',
                      path: '/sign-in'
                    })
                  }} 
                  className="hover:text-mixus-pumpkin transition-colors"
                >
                  Sign-In
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-mixus-light-beige/20">
          {/* <div className="flex flex-col items-center gap-8 mb-8">
            <Link 
              href="https://apps.apple.com/us/app/mixus-collaborative-ai-chat/id6737628969"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                posthog.capture('app_store_badge_clicked', {
                  location: 'footer',
                  source: 'app_store_badge'
                })
              }}
            >
              <Image
                src="/app-store-badge.svg"
                alt="Download on the App Store"
                width={180}
                height={60}
                className="h-[60px] w-auto transition-opacity hover:opacity-80"
              />
            </Link>
          </div> */}
          <div className="flex flex-col-reverse md:flex-row md:justify-between md:items-center">
            <p className="text-sm text-gray-400 text-center md:text-left">&copy; 2025 mixus</p>
            <Link
              href="/"
              onClick={() => {
                posthog.capture('footer_link_clicked', {
                  section: 'logo',
                  link: 'home',
                  path: '/'
                })
              }}
              className="mb-4 md:mb-0"
            >
              <Image
                src="/i_logo/i_primary/Horizontal/Knockout/SVG/mixus-logo-primary-horizontal-white.svg"
                alt="mixus logo"
                width={100}
                height={33}
                className="mx-auto md:mx-0"
              />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
} 